import React from "react";
import { ForgotPasswordContextProvider } from "./ForgotPasswordView";
import ForgotPasswordPage from "../ForgotPassword/views/ForgotPasswordPage";

const ForgotPassword = () => {
  return (
    <ForgotPasswordContextProvider>
      <ForgotPasswordPage />
    </ForgotPasswordContextProvider>
  );
};

export default ForgotPassword;
